module.exports = __webpack_public_path__ + "static/index/img/baikal-702.409b28dd.jpg";